import { Injectable } from "@angular/core";

@Injectable()
export class Utils {
  constructor(){

  }

   validNIE(nie: any) {
    let niePrefix = null;
    const nifRegex = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i;
    const nifLetters = "TRWAGMYFPDXBNJZSQVHLCKE";
    let valid = false;

    nie = nie.toUpperCase();
    if (9 === nie.length) {
      niePrefix = nie.charAt(0);
      switch (niePrefix) {
        case "X":
          niePrefix = 0;
          break;
        case "Y":
          niePrefix = 1;
          break;
        case "Z":
          niePrefix = 2;
          break;
        default:
          niePrefix = null;
          break;
      }
      nie = niePrefix + nie.substr(1);
      if (nie.match(nifRegex)) {
        valid = nie.charAt(8) === nifLetters.charAt(parseInt(nie, 10) % 23);
      }
    }

    return valid;
  }

   isNullOrEmpy(cadena) {
    if (cadena != null && cadena !== "") {
      return false;
    }
    return true;
  }

   validatedc(c1: any, c2: any, c3: any, c4: any, digitoControl: any): any {
    let parte1, parte2;

    parte1 = c1 + c2;

    parte2 = c4;

    let Apesos = new Array(1, 2, 4, 8, 5, 10, 9, 7, 3, 6);
    let DC1 = 0;
    let DC2 = 0;

    let x = 8;
    while (x > 0) {
      let digito = parte1.substr(x - 1, 1);
      DC1 = DC1 + Apesos[x + 1] * digito;
      x = x - 1;
    }

    let Resto = DC1 % 11;
    DC1 = 11 - Resto;

    if (DC1 == 10) {
      DC1 = 1;
    }
    if (DC1 == 11) {
      DC1 = 0;
    }

    x = 10;
    while (x > 0) {
      let digito = parte2.substr(x - 1, 1);
      DC2 = DC2 + Apesos[x - 1] * digito;
      x = x - 1;
    }

    Resto = DC2 % 11;
    DC2 = 11 - Resto;

    if (DC2 == 10) {
      DC2 = 1;
    }
    if (DC2 == 11) {
      DC2 = 0;
    }

    let DC = DC1 + "" + DC2;

    if (DC != digitoControl) {
      return false;
    } else {
      return true;
    }
  }

   validate(control: any): any {
    const codeLengths = {
      AD: 24,
      AE: 23,
      AL: 28,
      AT: 20,
      AZ: 28,
      BA: 20,
      BE: 16,
      BG: 22,
      BH: 22,
      BR: 29,
      CH: 21,
      CR: 21,
      CY: 28,
      CZ: 24,
      DE: 22,
      DK: 18,
      DO: 28,
      EE: 20,
      ES: 24,
      LC: 30,
      FI: 18,
      FO: 18,
      FR: 27,
      GB: 22,
      GI: 23,
      GL: 18,
      GR: 27,
      GT: 28,
      HR: 21,
      HU: 28,
      IE: 22,
      IL: 23,
      IS: 26,
      IT: 27,
      JO: 30,
      KW: 30,
      KZ: 20,
      LB: 28,
      LI: 21,
      LT: 20,
      LU: 20,
      LV: 21,
      MC: 27,
      MD: 24,
      ME: 22,
      MK: 19,
      MR: 27,
      MT: 31,
      MU: 30,
      NL: 18,
      NO: 15,
      PK: 24,
      PL: 28,
      PS: 29,
      PT: 25,
      QA: 29,
      RO: 24,
      RS: 22,
      SA: 24,
      SE: 24,
      SI: 19,
      SK: 24,
      SM: 27,
      TN: 24,
      TR: 26,
    };
    const iban = control.toUpperCase().replace(/[^A-Z0-9]/g, "");
    const code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]{20})$/);
    let digits: number;
    if (!code || iban.length !== codeLengths[code[1]]) {
      return { ibanValid: false };
    }
    digits = (code[3] + code[1] + code[2]).replace(
      /[A-Z]/g,
      (letter: string) => {
        return letter.charCodeAt(0) - 55;
      }
    );
    return this.mod97(digits) === 1
      ? { ibanValid: true }
      : { ibanValid: false };
  }

   mod97(digital: number | string) {
    digital = digital.toString();
    let checksum: number | string = digital.slice(0, 2);
    let fragment = "";
    for (let offset = 2; offset < digital.length; offset += 7) {
      fragment = checksum + digital.substring(offset, offset + 7);
      checksum = parseInt(fragment, 10) % 97;
    }
    return checksum;
  }

   validCIF(cif: any) {
    var cif = cif.toUpperCase();
    let v_letras_cif = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let v_longitud = cif.length;
    let v_letra = cif.substring(0, 1);
    let v_numero = cif.substring(1, v_longitud - 1);
    let v_ultimo_num = cif.substring(v_longitud - 1);

    if (v_letras_cif.indexOf(v_letra) == -1) {
      return false;
    }

    if (!/^[0-9A-J]$/.test(v_ultimo_num)) {
      return false;
    }

    let v_numerico;
    try {
      v_numerico = parseInt(v_numero);
    } catch (e) {
      return false;
    }

    let v_suma_par = 0;
    let v_suma_imp = 0;
    for (let i = 1; i <= 7; i++) {
      if (i % 2 == 0) {
        v_suma_par += parseInt(v_numero.substring(i - 1, i));
      } else {
        let v_suma_aux = parseInt(v_numero.substring(i - 1, i)) * 2;
        v_suma_aux = Math.trunc(v_suma_aux / 10) + (v_suma_aux % 10);
        v_suma_imp += v_suma_aux;
      }
    }

    let v_dg_control = 10 - ((v_suma_par + v_suma_imp) % 10);
    if (v_dg_control == 10) {
      v_dg_control = 0;
    }
    let v_letra_control = "";
    switch (v_dg_control) {
      case 1:
        v_letra_control = "A";
        break;
      case 2:
        v_letra_control = "B";
        break;
      case 3:
        v_letra_control = "C";
        break;
      case 4:
        v_letra_control = "D";
        break;
      case 5:
        v_letra_control = "E";
        break;
      case 6:
        v_letra_control = "F";
        break;
      case 7:
        v_letra_control = "G";
        break;
      case 8:
        v_letra_control = "H";
        break;
      case 9:
        v_letra_control = "I";
        break;
      case 0:
        v_letra_control = "J";
        break;
    }
    if (
      v_ultimo_num != v_dg_control.toString() &&
      v_ultimo_num != v_letra_control
    ) {
      return false;
    } else {
      return true;
    }
  }

   validNIF(nif: any) {
    const nifRegex = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]{1}$/i;
    const nifLetters = "TRWAGMYFPDXBNJZSQVHLCKE";
    let valid = false;

    nif = nif.toUpperCase();
    if (9 === nif.length) {
      if (nif.match(nifRegex)) {
        valid = nif.charAt(8) === nifLetters.charAt(parseInt(nif, 10) % 23);
      }
    }

    return valid;
  }

}
